import $ from 'jquery';

const parralaxTitle = () => {
  const offset = $(window).scrollTop() ;
  const translateY = 50 + (offset / 8);

  $('.page-header--home__container').css(
    'transform', 'translateY(-' + translateY + '%)',
  )
}

$(window).scroll( function() {
  parralaxTitle();
});
